var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProject1Length(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1649_18227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00109 0.498944C0.319517 0.483826 0.319517 1.51398 1.00109 1.4989H11.0001C11.6817 1.51402 11.6817 0.483864 11.0001 0.498944H1.00109ZM5.99132 2.49892C5.86198 2.5027 5.73876 2.55467 5.64757 2.64632L4.23058 4.06042C3.75792 4.53307 4.46691 5.24202 4.93956 4.76937L5.50011 4.20592V7.79185L4.93956 7.23129C4.43067 6.73108 3.74031 7.43412 4.23058 7.93931L5.64757 9.35335C5.84261 9.54724 6.15761 9.54724 6.35265 9.35335L7.76671 7.93931C8.2799 7.4698 7.53605 6.70072 7.06163 7.23129L6.50109 7.78891V4.20881L7.06163 4.76937C7.53424 5.25872 8.25868 4.53031 7.76671 4.06042L6.35265 2.64632C6.25715 2.55032 6.12676 2.49703 5.99132 2.49892ZM1.00109 11.5019H11.0001C11.6674 11.5019 11.6674 10.5009 11.0001 10.5009H0.975207C0.282011 10.5355 0.333769 11.5364 1.00109 11.5019Z",
    fill: "#A3A4AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1649_18227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject1Length);
export default __webpack_public_path__ + "static/media/project1_length.19238d77ccdfcea801f6e9a1258e592c.svg";
export { ForwardRef as ReactComponent };